import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {RolneZaProizvodnjuModel} from '../models/RolneZaProizvodnju'

const API_URL = process.env.REACT_APP_API_URL
const API_ZA_PROIZ = `${API_URL}/trake/getRolneZaProizvodnju`
const API_U_PROIZ = `${API_URL}/trake/getRolneUProizvodnji`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function getRolneZaProizvodnju(params: any) {
  return await axios.get<Array<RolneZaProizvodnjuModel>>(API_ZA_PROIZ, {
    headers: headers,
    params: params,
  })
}
export async function getRolneUProizvodnju(params: any) {
  return await axios.get<Array<RolneZaProizvodnjuModel>>(API_U_PROIZ, {
    headers: headers,
    params: params,
  })
}

export async function updateProizvediRolnu(data: any) {
  try {
    const response = await axios.get(`${API_URL}/trake/proizvediRolnu`, {
      headers: headers,
      params: data,
    })

    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error Saving data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function zavrsiProizvodnjuRolne(data: any) {
  try {
    const response = await axios.post(`${API_URL}/trake/zavrsiProizvodnjuRolne`, data, {
      headers: headers,
    })

    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error Saving data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}
